import { getElementExists } from "../../../resources/js/helper/helper";
import Swiper from "swiper";
import { Thumbs, Grid, Navigation, Pagination } from "swiper/modules";

(function () {
  const swiperSliders = document.querySelectorAll(".mb-image-slider");

  let imageSwiper = [];

  const standardSlidesPerView = 3;

  for (let i = 0; i < swiperSliders.length; i++) {
    const paginationEl = swiperSliders[i]
      .closest(".com-image-slider")
      .querySelector(".swiper-pagination");
    const navigationWrapper = swiperSliders[i]
      .closest(".com-image-slider")
      .querySelector(".swiper-navigation");
    const nextEl = navigationWrapper.querySelector(".swiper-button-next");
    const prevEl = navigationWrapper.querySelector(".swiper-button-prev");

    imageSwiper[i] = new Swiper(swiperSliders[i], {
      modules: [Pagination, Navigation],
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 15,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        920: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
      },
    });

    initThreeImageSlider(swiperSliders[i].closest(".com-image-slider"));
  }
})();

function adjustSlidesOpacity(slideElementsArray, slidesPerView) {
  if (slidesPerView >= 2) {
    slideElementsArray.forEach((el) => {
      el.style.opacity = 0;
    });
    const activeElement = slideElementsArray.find((el) => {
      return el.classList.contains("swiper-slide-active");
    });

    if (getElementExists(activeElement)) {
      activeElement.style.opacity = 1;

      setSiblingsOpacity(activeElement, slidesPerView - 1);
    }

    return;
  } else {
    slideElementsArray.forEach((el) => {
      el.style.opacity = 1;
    });
  }
}

function setSiblingsOpacity(el, siblings) {
  if (siblings < 1) {
    return;
  }

  if (el.nextElementSibling) {
    el.nextElementSibling.style.opacity = 1;

    setSiblingsOpacity(el.nextElementSibling, siblings - 1);
  } else {
    return;
  }
}

function initThreeImageSlider(parentElement) {
  let currentIndex = 0;

  const controls = parentElement.querySelector(".swiper-controls");
  const pagination = controls.querySelector(".swiper-pagination");

  const navigation = controls.querySelector(".swiper-navigation");
  const prevEl = navigation.querySelector(".swiper-button-prev");
  const nextEl = navigation.querySelector(".swiper-button-next");

  setActiveSlides(parentElement, currentIndex);

  prevEl.addEventListener("click", () => {
    handleThreeImageSliderChange(parentElement, -1);
  });
  nextEl.addEventListener("click", () => {
    handleThreeImageSliderChange(parentElement, 1);
  });

  pagination.addEventListener('click', (evt) => {
    if(!getElementExists(evt.target.closest('.swiper-pagination-bullet'))) return;
    handleThreeImageSliderChange(parentElement, 0, evt.target.closest('.swiper-pagination-bullet'));
  })
}

function handleThreeImageSliderChange(parentElement, direction, bulletElement = null) {
  const currenIndex = +parentElement.querySelector('.mb-slide').dataset.activeIndex;

  const newActiveIndex = direction != 0 ? getIndexFromDirection(parentElement, currenIndex, direction) : getIndexFromBullets(parentElement, bulletElement);

  setActiveSlides(parentElement, newActiveIndex);
}

function getIndexFromDirection(parentElement, currenIndex, direction) {
  const imageCount = parentElement.querySelectorAll('.mb-slide').length / 3;

  if(currenIndex + direction >= imageCount) {
    return 0;
  }

  if(currenIndex + direction < 0) {
    return imageCount - 1;
  }

  return currenIndex + direction;
}

function getIndexFromBullets(parentElement, bulletElement) {
  const bulletElements = Array.from(parentElement.querySelector('.swiper-pagination-bullets').childNodes);

  return bulletElements.indexOf(bulletElement) != -1 ? bulletElements.indexOf(bulletElement) : 0;
}

function setActiveSlides(parentElement, currentIndex) {
  const imageSliderLargeWrapperElement = parentElement.querySelector(
    ".mb-image-slider-large"
  );

  const firstImagesContainer = imageSliderLargeWrapperElement.querySelector('.mb-image-slider-large--first-images');
  const firstImages = firstImagesContainer.querySelectorAll('.mb-slide');

  const secondImagesContainer = imageSliderLargeWrapperElement.querySelector('.mb-image-slider-large--second-images');
  const secondImages = secondImagesContainer.querySelectorAll('.mb-slide');

  const thirdImagesContainer = imageSliderLargeWrapperElement.querySelector('.mb-image-slider-large--third-images');
  const thirdImages = thirdImagesContainer.querySelectorAll('.mb-slide');

  const bulletElements = parentElement.querySelector('.swiper-pagination-bullets').childNodes;

  for(let i = 0; i < firstImages.length; i++) {
    firstImages[i].setAttribute('data-active-index', currentIndex);
    firstImages[i].classList.remove('active');
    secondImages[i].setAttribute('data-active-index', currentIndex);
    secondImages[i].classList.remove('active');
    thirdImages[i].setAttribute('data-active-index', currentIndex);
    thirdImages[i].classList.remove('active');

    bulletElements[i].classList.remove('swiper-pagination-bullet-active');

    if(i == currentIndex) {
      firstImages[i].classList.add('active');
      secondImages[i].classList.add('active');
      thirdImages[i].classList.add('active');
      bulletElements[i].classList.add('swiper-pagination-bullet-active');
    }
  }
}
